import { render, staticRenderFns } from "./LicenceRenderer.vue?vue&type=template&id=7c70aabd&"
import script from "./LicenceRenderer.vue?vue&type=script&lang=js&"
export * from "./LicenceRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports